import { formatDateYmd } from "./governingBodyApi";

export const updateDataGoverningBodies = (rows) => {
  return (rows || []).map((row) => ({
    id: row?.id ?? "",
    abbreviation: row?.abbreviation ?? "",
    imageUrl: row?.imageSmallUrl || row?.imageUrl || "",
    name: row?.name ?? "",
    shortName: row?.shortName ?? "",
    outputSequence: row?.outputSequence ?? "",
    ddListDescription: row?.ddListAbbreviation || row?.ddListDescription || "",
    parentId: row?.parentName || row?.parentShortName || row?.parentId || "",
    teamType: row?.teamType ?? "",
    teamName: row?.teamName ?? "",
    ageCutoffMonth: row?.ageCutoffMonth ?? "",
    ageCutoffDay: row?.ageCutoffDay ?? "",
    status: row?.status ?? "",
    createdAt: formatDateYmd(row?.createdAt),
    createdBy: row?.createdBy ?? "",
    updatedAt: formatDateYmd(row?.updatedAt),
    updatedBy: row?.updatedByName || row?.updatedBy || "",
  }));
};
